var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar",attrs:{"role":"navigation","aria-label":"main navigation"}},[_c('navbar-brand')],1)}
var staticRenderFns = []

export { render, staticRenderFns }